var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isDlp)?_c('DiscoveryPageLoader',{attrs:{"id":_vm.id}}):_c('CategoryPageLoader',{attrs:{"media-type-path":_vm.mediaType,"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }